module.exports = __webpack_public_path__ + "img/5.aa3b29d6.jpg";